var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{attrs:{"width":"800","height":"250"}}),_vm._v(" "),_c('ChannelTypeBreakdownModal',{attrs:{"period":_vm.period,"portal":_vm.portal,"dataset":_vm.dataset}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }